module.exports = __webpack_public_path__ + "static/media/cq_bozza_messaggio.90281929.svg";